/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * WAVE Custom: Check inventory availability by location using an AJAX call.
 */
if(document.getElementById("wc-check-availability-link")) {
document.getElementById("wc-check-availability-link").addEventListener("click", function(event){
  event.preventDefault();
  
  document.getElementById("wc-check-availability-link-container").style.display = "none";
  document.getElementById("wc-display-availability-container").style.display = "block";
  
  var url = document.getElementById("wc-check-availability-link").getAttribute("data-url");
  
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = function() {
  	if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {        
      	try {
        	var data = JSON.parse(xmlhttp.responseText);
        } catch(err) {
            console.log(err.message + " in " + xmlhttp.responseText);
            return;
        }
      
        if (data.success) {
          document.getElementById("wc-display-availability-container").innerHTML = "";
          
          for(var i = 0; i < data.inventory.length; i++) {
              var obj = data.inventory[i];
			  var location = '';
            
              if (obj.location == 64150470839) {
                  location = 'Austin';
              } else if (obj.location == 64151126199) {
                  location = 'Baton Rouge'; 
              } else if (obj.location == 64151158967) {
                  location = 'Dallas';
              } else if (obj.location == 64151191735) {
                  location = 'Fort Lauderdale';
              } else if (obj.location == 64096600247) {
                  location = 'Houston DC';
              } else if (obj.location == 64151224503) {
               	  location = 'New Orleans'; 
              } else if (obj.location == 64151257271) {
                  location = 'North Houston';
              } else if (obj.location == 64151290039) {
                  location = 'San Antonio';
              } else if (obj.location == 64151322807) {
                  location = 'Scottsdale';
              } else if (obj.location == 64151388343) {
                  location = 'South Houston';
              }
            
              document.getElementById("wc-display-availability-container").innerHTML += location + ": " + obj.quantity + " In Stock<br />";
          }
        } else {
          document.getElementById("wc-display-availability-container").innerHTML = "Could not check availability.";
        }
    }
  };
 
  xmlhttp.open("GET", url, true);
  xmlhttp.send();
});
}
/**
 * WAVE Custom: Hide variants that do not have an image.
 */
$( document ).ready(function() {
  if( typeof product_variants_removed != "undefined" ) {    // was there items to be removed?
    var $addToCartForm = $('form[action="/cart/add"]');
    if (window.MutationObserver && $addToCartForm.length) {
      if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
        console.log('inside disconnect statement');
        observer.disconnect();
      }
      var config = { childList: true, subtree: true };
      var observer = new MutationObserver(function() {
        product_variants_removed.forEach(function(item){
          $('.product-form__single-selector').each(function () {
            if ($(this).val() === item) {
              $(this).parents('div[class^="block-swatch"]').eq(0).remove(); 
              $('label.block-swatch__item').first().trigger('click');
            }
          });

          //$('.product-form__single-selector').filter(function() { return $(this).val() === item; }).remove();
        });
        observer.disconnect();
      });
      observer.observe($addToCartForm[0], config);
      //$('.block-swatch__radio product-form__single-selector').trigger('change');
    }
  }

  var promotional_end_date_countdownEl = $('.promotional_end_date_countdown');
  if(promotional_end_date_countdownEl.length) {

    function msToTime() {  
      var endDateStr = promotional_end_date_countdownEl.attr('data-time');
      var endDate = new Date(endDateStr);
      var today = new Date();

      var hourDiff = endDate - today;
      var minutes = parseInt((hourDiff / (1000 * 60)) % 60),
          hours = parseInt(hourDiff / (1000 * 60 * 60) % 24),
          days = (parseInt(hourDiff / (1000 * 60 * 60 * 24)));

      if( hourDiff <= 60000) {
        clearTimeout(timerId);
        $('.promotional_end_date_row').hide();
      } 


      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (hours < 10) {
        hours = '0' + hours;
      }
       if (days < 10) {
        days = '0' + days;
      }
      var timeStr = "<span>"+days+"d:"+hours+"h:"+minutes+"m</span>";
      promotional_end_date_countdownEl.html(timeStr);

    };
    msToTime();
    var timerId = setInterval(function() {
      msToTime();
    }, 1000);

  }
});